module.exports = __webpack_public_path__ + "img/basic_information.bc268714.png";